import { library } from '@fortawesome/fontawesome-svg-core'
import { faLock, faCat, faMinus, faPlus, faTimes, faArrowLeft, faCheckSquare, faCoffee, faChevronRight, faChevronLeft, faGlobe, faMoneyBill, faCreditCard, faUniversity, faTruck, faCommentDollar } from '@fortawesome/free-solid-svg-icons'
library.add(faLock, faCat, faMinus, faPlus, faTimes, faArrowLeft, faCheckSquare, faCoffee, faChevronRight, faChevronLeft, faGlobe, faMoneyBill, faCreditCard, faUniversity, faTruck, faCommentDollar)


